export default __webpack_public_path__ + "static/media/messenger.6ca8c47b.svg";